import * as config from '@/config/config.json';
import * as calculatorConfig from '@/config/base-config.json';
import { generateSliderSteps } from '@/utils/generateSliderSteps';

export const OTHERS_RENTAL_YIELD_LABEL = {
  GrossRentalYield: 'Gross Rental Yield',
  NetRentalYield: 'Net Rental Yield',
  PropertyValueEstimated: 'Property Value (Estimated)',
  MonthlyRentalPrice: 'Monthly Rental Price',
  Summary: 'Summary',
  AnnualRentalIncome: 'Annual Rental Income',
  SummaryNote:
    'The property rental yield calculator is to help you get an idea of how much returns you are getting if you are leasing out to tenants. Typically, property investors would compare the yield to the mortgage interest and the interest rates the banks are offering. If the rental yield is greater than the mortgage interest and bank interest rates, it is usually a good indicator to invest in the property.',
  AnnualShaving: 'Annual Shaving',
  AnnualShavingTootltip:
    'To be conservative, it is recommended that you shave 5% off your annual rental income. This is to account for the occasional disruption, such as a weak rental market, or being forced to take on a tenant at a lower rate.',
  PropertyTaxAnnual: 'Property Tax (Annual)',
  MonthlyMaintenanceFee: 'Monthly Maintenance Fee',
  ServiceCommission: 'Service Commission',
  Others: 'Others',
  BankLoanInterestYearly: 'Bank Loan Interest (Yearly)',
  CalculateForMe: 'Calculate for me',
  LoanAmount: 'Loan Amount',
  LoanTenureYears: 'Loan Tenure (Years)',
  InterestRate: 'Interest Rate',
  LoanStartYear: 'Loan Start Year',
  MonthlyPayment: 'Monthly Payment',
  TotalInterestPaid: 'Total Interest Paid',
  BankLoanInterest: 'Bank Loan Interest',
  Calculate: 'Calculate',
};

export const INTEREST_RATE = calculatorConfig.mortgage_interest_rate.private_resale.default;

export enum RENTAL_YIELD {
  GROSS = 'Gross',
  MORE = 'More',
}

export const LOAN_TENURE = {
  LABEL_INPUTS: generateSliderSteps(
    0,
    config.max_loan_tenure_in_years.private_residential.upto_75_financing_year,
    10,
  ),
  MAX: config.max_loan_tenure_in_years.private_residential.upto_75_financing_year,
  STEP: 1,
  DEFAULT: config.max_loan_tenure_in_years.private_residential.upto_75_financing_year,
};
